export default {
  aggregates: {
    aggregated: 'النتائج المجمعة',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'مضت',
    from: 'من',
    since: 'منذ',
    unit: {
      DAY: 'يوم|أيام',
      MONTH: 'شهر|شهور',
      YEAR: 'سنة|سنوات'
    },
    untilNow: 'إلى الآن'
  },
  categoryDetails: {
    average: 'متوسط القيمة هو {average}. {benchmark}',
    chartLabel: {
      noLabel: 'لا',
      yesLabel: 'نعم'
    },
    description:
      'يوضح هذا كيفية توزيع إجابات الفريق على جميع الأسئلة في الفئة.',
    hideOwnAnswers: 'إخفاء إجاباتك',
    noResponses: 'لا توجد إجابات',
    notParticipating: 'أنت لم تُجب عن هذه الأسئلة بنفسك.',
    numberOfPeople: 'المشاركون',
    sensitiveQuestion: 'يظهر لك فقط كمدير.',
    showFollowUpQuestions: 'إظهار أسئلة المتابعة',
    toggleButton: {
      overview: 'ملخص',
      questions: 'أسئلة'
    },
    tooltip: {
      barValue: 'لا أحد | {count} شخص | {count} أشخاص',
      barValueAnswers: 'لا توجد إجابات | {count} إجابة | {count} إجابات'
    },
    workWith: 'كيفية العمل مع {categoryName}',
    yourResponse: 'لقد أجبت:'
  },
  error: {
    couldNotLoadAggregates: 'تعذر تحميل النتائج المجمعة.',
    couldNotLoadResults: 'تعذر تحميل النتائج.',
    networkError:
      'حدثت مشكلة أثناء تحميل البيانات من الإنترنت. هل لديك اتصال يعمل؟',
    unknown: 'حدث خطأ غير معروف'
  },
  errors: {
    status: {
      BadRequest: 'طلب خاطئ للخادم',
      Forbidden: 'غير مسموح لك بالوصول إلى هذا المحتوى',
      InternalServerError:
        'حدث خطأ ما في الخادم، يُرجى التواصل مع خدمة الدعم الفني إذا ما استمر هذا الخطأ.',
      NotFound: 'لم يتم العثور على ما تبحث عنه',
      Unauthorized: 'غير مسموح لك بالوصول إلى هذا المصدر',
      UnknownError: 'حدث خطأ غير معروف'
    }
  },
  freetext: {
    loadResponses: 'تحميل الردود',
    noFreeTextQuestions:
      'عند وجود أسئلة نصية مجانية في استبيانك، ستتمكن من رؤية جميع الردود هنا.',
    notEnoughResponses: 'لا توجد ردود كافية.',
    responses: 'لا توجد ردود |{count} رد |{count} ردود'
  },
  general: {
    add: 'إضافة',
    cancel: 'إلغاء',
    entireOrganization: 'المؤسسة بأكملها',
    ok: 'موافقة'
  },
  groupsComparison: {
    averageForItem:
      '{value} هي متوسط قيمة الأسئلة داخل {title}. {compareToBenchmark}',
    currentValue: 'القيمة الحالية',
    filter: {
      findGroups: 'ابحث عن مجموعات',
      shouldExportWithHierarchy: 'بما في ذلك المجموعات الأساسية'
    },
    loadMore: 'تحميل المزيد',
    loadMoreInGroup: 'تحميل المزيد ضمن {groupName}',
    noone: 'لم يجيب أحد',
    noResults:
      'لا توجد إجابات كافية لهذه المجموعة حتى الآن. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'أجابوا',
    nps: 'صافي نقاط الترويج',
    nps_detractors: 'المنتقدين',
    nps_passives: 'السلبيين',
    nps_promoters: 'المروجين',
    questions: 'أسئلة في الفئة',
    showTrend: 'إظهار التغيير',
    violationsIn:
      'تم الإبلاغ عن حدوث انتهاكات داخل {groupName}. يرجى الاتصال بقسم الموارد البشرية الذي يمكنه إخبارك بالمزيد ومساعدتك في الخطوات التالية للتعامل مع المشكلة.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'حدد تاريخًا كنقطة بداية لعرض البيانات التاريخية.',
      selectDate: 'سيتم عرض البيانات التاريخية للاستبيانات منذ تاريخ {date}.',
      selectedDate: 'عرض البيانات التاريخية للاستبيانات منذ تاريخ {date}.'
    },
    selectorOptions: {
      custom: 'تخصيص',
      oneMonth: '1m',
      oneYear: '12m',
      sixMonths: '6m'
    }
  },
  loading: {
    error: {
      link: 'أعد المحاولة'
    }
  },
  navbar: {
    administration: 'المسؤول',
    currentSurveys: 'الاستبيانات الحالية',
    help: 'مساعدة',
    myActivities: 'الإجراءات',
    ourResults: 'النتائج',
    overview: 'نظرة عامة',
    team: 'الفريق',
    welcome: 'مرحبًا'
  },
  page: {
    results: 'جميع النتائج'
  },
  resultDetails: {
    backToResults: 'رجوع',
    exportData: 'تصدير',
    exportModal: {
      includeSensitiveQuestions: 'إدراج أسئلة حساسة',
      loadingMessage: 'جارٍ تحضير البيانات للتصدير، سيستغرق ذلك بعض الوقت.',
      saveAsExcelAllGroupsDescription:
        'عند التصدير إلى Excel، ستحصل على ملف يحتوي على نتائج {groupTitle} وجميع المجموعات الأساسية. يعد هذا أمرًا جيدًا إذا كنت تريد إجراء تحليل أو حسابات متعددة المجموعات بنفسك.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'عند التصدير إلى Excel، ستحصل على ملف يحتوي على نتائج {groupTitle}{segmentInfo}. يعد هذا أمرًا جيدًا إذا كنت تريد إجراء تحليل أو حسابات بنفسك.',
      saveAsPdfButton: 'ملف PDF',
      saveAsPdfDescription:
        'ستحصل على ملف PDF يحتوي على نتائج جميع الفئات وأسئلة المجموعة المحددة. مفيد عند طباعة النتائج.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'سيوفر لك تصدير ملف PowerPoint عرضًا تقديميًا رائعًا لنتائج {groupTitle}{segmentInfo}. خيار مثالي لعرض النتائج على الآخرين على شاشة كبيرة.'
    },
    notes: {
      draggable: {
        explanation: 'مرئي لك فقط',
        placeholder:
          'يمكنك كتابة ملاحظاتك وتعليقاتك وتأملاتك حول استطلاع الرأي هنا',
        title: 'الملاحظات الشخصية'
      },
      status: {
        initial: 'الحفظ تلقائيًا أثناء الكتابة',
        saved: 'تم حفظ التغييرات!',
        unsaved: 'جارٍ الحفظ قريبًا...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses: 'لا توجد إجابات كافية لعرض النتائج لكل مستخدم'
        },
        description: {
          high: 'قام شخص واحد بالرد حتى أصبح متوسط درجاته باللون الأخضر. | هناك {count} أشخاص قاموا بالرد حتى أصبح متوسط درجاتهم باللون الأخضر.',
          low: 'قام شخص واحد بالرد حتى أصبح متوسط درجاته باللون الأحمر. | هناك {count} أشخاص قاموا بالرد حتى أصبح متوسط درجاتهم باللون الأحمر.',
          medium:
            'قام شخص واحد بالرد حتى أصبح متوسط درجاته باللون الأصفر. | هناك {count} أشخاص قاموا بالرد حتى أصبح متوسط درجاتهم باللون الأصفر.'
        },
        title: 'لا أحد | شخص واحد | {count} أشخاص'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'نتيجتك مساوية لمعيار ®Puls ᐩ benchmark لـ {title}.',
        higherThanBenchmarkValue:
          'نتيجتك أعلى بمقدار {benchmarkDiff} من معيار ®Pulsᐩ benchmark لـ {title} وهي {benchmarkValue}. جيد!',
        lowerThanBenchmarkValue:
          'أنت أقل بمقدار {benchmarkDiff} من معيار ®Puls ᐩ benchmark لـ {title} وهو {benchmarkValue}',
        percentagePoints: 'نقاط مئوية'
      },
      enps: {
        button: {
          description:
            'سيتم إرسالك إلى شريكنا، EQI، الذي يجمع بيانات قياس الأداء لعدد كبير من المؤسسات ويقدم رؤية أكثر تفصيلاً فيما يتعلق بنتيجة eNPS الخاصة بك.',
          title: 'قارن درجاتك في eNPS مع المؤسسات الأخرى'
        }
      },
      toggleButton: {
        history: 'البيانات التاريخية',
        overview: 'نظرة عامة'
      }
    }
  },
  results: {
    aggregated: 'المجمَّع',
    chooseSurvey: 'حدد الاستبيان',
    finished: 'مكتمل',
    published: 'جاري التنفيذ'
  },
  resultsmessages: {
    disclaimer: 'يستخدم Pulsᐩ AI الذكاء الاصطناعي التوليدي وقد يخطئ',
    error: {
      generic:
        'لا، يا إلهي!... حدث خطأ ما غير متوقع. يُرجى إعادة تحميل الصفحة.',
      notEnoughResults:
        'لا توجد نتائج للحديث حولها. يُرجى اختيار مجموعة أو استبيان آخر لاستخدام Pulsᐩ AI.'
    },
    moreInfo: 'تعرَّف على كيفية استخدام ᐩ AI  كقائد',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'اطرح سؤالاً حول النتائج...',
    reload: 'إعادة تحميل الصفحة',
    report: 'الإبلاغ عن مشكلة',
    send: 'إرسال',
    suggestionHeader: 'إليك بعض الاقتراحات للأسئلة التي يمكنك طرحها:',
    suggestions: {
      groupsComparison: {
        1: 'ما المجموعات التي يجب أن أركز عليها؟',
        2: 'هل هناك أي سؤال يجب على معظم المجموعات العمل عليه؟',
        3: 'ما المجموعات التي تظهر اتجاهات سلبية؟',
        4: 'ما هي المجموعات التي لديها اتجاهات إيجابية؟',
        5: 'ما هي المجموعات التي تبرز بشكل سلبي؟',
        6: 'ما هي المجموعات التي تحتاج إلى انتباهي؟',
        7: 'ماذا يجب أن أفعل أولاً؟'
      },
      overview: {
        1: 'ماذا أفعل بنتائجنا؟',
        2: 'كيف يمكنني تقديم هذا لفريقي؟',
        3: 'بشكل عام، كيف تبدو النتائج؟',
        4: 'ما هي أهم 3 إجراءات يجب أن نتخذها؟',
        5: 'ما الذي يمكنني تحسينه في قيادتي؟',
        6: 'ما هي المخاطر التي نواجهها؟',
        7: 'ماذا يمكن أن يحدث إذا لم نتصرف؟',
        8: 'ما الذي يجب أن أعطيه الأولوية؟',
        9: 'ما هي التوقعات لفريقي؟'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'الجميع'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'مقارنة'
        },
        export: {
          title: 'تصدير'
        },
        freetext: {
          title: 'نص مفتوح'
        },
        results: {
          title: 'نتائج الاستبيان'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses: 'لا يمكن عرض الإحصاءات دون المخاطرة بالكشف عن الهوية.',
    others: 'أخرى | غير ذلك',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'الإدارة',
    currentSurveys: 'الاستبيانات الحالية',
    dashboard: 'لوحة التحكم',
    help: 'مساعدة',
    logOut: 'تسجيل الخروج',
    myActivities: 'أنشطتي',
    ourResults: 'نتائجنا'
  },
  topbanner: {
    preview: {
      body: 'أنت الآن تبحث عن الإصدار الجديد من عرض نتائج Pulsᐩ الذي يتضمن العديد من التحسينات! إذا ما واجهتك أي مشكلة، أو إذا كانت لديك أي ملاحظات، يُرجى منك إعلامنا بذلك! يمكنك أيضًا الرجوع إلى الإصدار القديم إذا أردت ذلك.',
      header: 'إصدار جديد!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'خلال الفترة الزمنية {startDate} - {EndDate} انخفضت النتيجة لـ {categoryName}.',
        trend_increased:
          'خلال الفترة الزمنية {startDate} - {EndDate} زادت النتيجة لـ {categoryName}. استمروا في العمل الجيد!',
        trend_same:
          'بقيت النتيجة كما هي لـ {categoryName} خلال الفترة الزمنية {startDate} - {EndDate}.'
      }
    },
    noTrend: 'لا يوجد استبيان أقدم للمقارنة به.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'مقارنةً بالاستبيان السابق في {oldSurveyDate}، انخفضت النتيجة بنسبة {changeInPercent}% لـ {tagName}.',
        nps_trend_increased:
          'مقارنةً بالاستبيان السابق في {oldSurveyDate}، زادت النتيجة بنسبة {changeInPercent}% لـ {tagName}.',
        nps_trend_same:
          'ظلت النتيجة كما هي تقريبًا (تغيير {changeInPercent}%) لـ {tagName} منذ الاستبيان الأخير في {oldSurveyDate}.',
        trend_decreased:
          'خلال الفترة الزمنية {startDate} - {endDate} انخفضت النتيجة لـ {TagName}.',
        trend_increased:
          'خلال الفترة الزمنية {startDate} - {endDate} زادت النتيجة لـ {tagName}',
        trend_same:
          'بقيت النتيجة كما هي لـ {categoryName} خلال الفترة الزمنية {startDate} - {EndDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'جميع المجموعات',
    cannotChangeGroupsWhileComparing:
      'أثناء عرض المقارنة، يمكنك النظر إلى مجموعات متعددة في نفس الوقت.',
    group: 'المجموعة',
    segment: 'الجزء',
    survey: 'الاستبيان'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'عدد الأشخاص الذين قاموا باختيار إجراء واحد على الأقل',
      totalActions: 'إجمالي عدد الإجراءات المختارة'
    },
    title: 'ملخص الإجراءات'
  },
  widgetAlert: {
    actions: {
      saved: 'شكرًا، تم حفظ النشاط.'
    },
    links: {
      tooltip: 'يفتح الرابط في نافذة جديدة'
    },
    notEnoughData: 'لا يوجد شيء لعرضه هنا الآن.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'آخر استبيان تم الإبلاغ عنه {surveyDate}.'
      },
      question: {
        info: 'آخر ما تم طرحه {surveyDate} في "{surveyTitle}".'
      }
    },
    notEnoughResponses: 'لا توجد إجابات كافية حتى الآن لعرض أي شيء هنا.',
    title: 'الفئات',
    tooltip: {
      value:
        'هذه هي القيمة المتوسطة لجميع الإجابات على الأسئلة في {categoryName} التي أجاب عليها الأشخاص في {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      'حدث خطأ غير متوقع أثناء تحميل عنصر واجهة المستخدم. يُرجى إعادة تحميل الصفحة أولًا. إذا ما استمرت هذه المشكلة، يُرجى إبلاغنا وسنُعالجها على الفور!',
    hideErrorDetails: 'إخفاء التفاصيل',
    showErrorDetails: 'إظهار التفاصيل',
    title: 'مشكلة في عنصر واجهة المستخدم!'
  },
  widgetGroupActions: {
    allCategories: 'ضمن كل الفئات',
    freeText: {
      alert: {
        noResults: 'لم يتم العثور على شيء. جرّب كتابة شيء آخر.',
        typeMore: 'اكتب المزيد'
      },
      filterField: {
        placeholder: 'اكتب للعثور على تعليقات'
      },
      numberOfComments: '{numberOfComments} تعليقات'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title: 'كيفية تطوير مسؤوليتك الخاصة مع موظفيك'
      }
    },
    noActions: 'لا توجد أنشطة لعرضها.',
    noActionsSelectedInCategory: 'لم يتم تحديد أنشطة',
    otherActions: 'الأنشطة الخاصة',
    people: 'لا أحد | {count} شخص | {count} أشخاص',
    peopleSelectedActions:
      'من بين {peopleResponded} أشخاص أجابوا، اختار شخص واحد فقط إجراءً واحدًا على الأقل ({percentage}%) | من بين {peopleResponded} أشخاص أجابوا، اختار {count} أشخاص إجراءً واحدًا على الأقل ({percentage}%)',
    title: 'الأنشطة المختارة للأشخاص في {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        'اختار شخص واحد هذا الإجراء | اختار {count} أشخاص هذا الإجراء'
    }
  },
  widgetGroupPriorities: {
    description:
      'هذه هي أهم المجالات التي يجب التركيز عليها الآن، وفقًا للمشاركين في الاستبيان.',
    freeTextResponses: 'عرض إجابات نصية مجانية',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'كيفية تطوير فريقك باستخدام Puls+'
      }
    },
    noPriorities: 'لا توجد أولويات يختارها المشاركون.',
    people: 'لا أحد | {count} شخص | {count} أشخاص',
    thinkImportant: ' أعتقد أن "{category}" هي الأكثر أهمية',
    title: 'أولويات الأشخاص في {groupName}'
  },
  widgetNotImplemented: {
    content: 'لم يُنفذ بعد'
  },
  widgetSurveyInfo: {
    endDate: 'تاريخ الانتهاء',
    noone: 'لم يجيب أحد',
    notEnoughResponses: {
      aggregate:
        'لم يُجب عدد كافٍ من الأشخاص خلال الفترة الزمنية لعرض النتائج.',
      completed: 'لم يُجب عدد كافٍ من الأشخاص على الاستبيان لعرض النتائج.',
      published:
        'لم يُجب عدد كافٍ من الأشخاص حتى الآن على الاستبيان لعرض النتائج.'
    },
    participation: {
      title: 'المشاركة'
    },
    startDate: 'تاريخ البدء',
    status: {
      completed: 'اكتمل الاستبيان! هذه هي النتائج النهائية.',
      published: 'الاستبيان لا يزال جاريًا. النتائج أولية.'
    },
    usersInvited: 'الأشخاص المدعوون',
    usersResponded: 'الأشخاص الذين أجابوا'
  },
  widgetTagsDonuts: {
    description: {
      all: 'هذه هي أحدث النتائج لـ {groupName}.'
    },
    notEnoughResponses: 'لا توجد إجابات كافية حتى الآن لعرض أي شيء هنا.',
    title: {
      company: '{organizationName} كل'
    },
    tooltip: {
      enps_description:
        'يرمز eNPS إلى "صافي نقاط الترويج للموظف" ويقيس مدى استعداد الموظفين لدعوة الناس للعمل في شركتهم.',
      nps_description:
        'يرمز NPS إلى "صافي نقاط الترويج" وهو مقياس لمدى احتمالية أن يوصي الناس غيرهم بشيء ما.',
      nps_detractors: 'المنتقدين',
      nps_passives: 'السلبيين',
      nps_promoters: 'المروجين',
      value:
        'هذه هي القيمة المتوسطة لجميع الإجابات على الأسئلة في {tagName} التي أجاب عليها الأشخاص في {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} بمرور الوقت',
    twoTags: '{tag1} و {tag2}'
  }
}
